<template>
  <div id="stockdetail">
    <el-row>
        <el-col :span="6" :offset="9">
            <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000">盘库详情</h1>
        </el-col>
    </el-row>
    <el-row style="margin: 20px auto" type="flex" justify="space-between">
      <div class="item">
        <span>
          盘库日期：{{stock_date}}
        </span>
      </div>
      <div class="item">
        <span>
          盘库单编号：{{stock_code}}
        </span>
      </div>
    </el-row>
    <el-row>
        <el-col :span="24">
            <table style="width: 100%">
                <tr>
                    <th style="width: 5%">序号</th>
                    <th style="width: 40%">产品</th>
                    <th style="width: 10%">单位</th>
                    <th v-if="WAREHOUSE_MODE == 2">库位</th>
                    <th style="width: 10%">库存数量</th>
                    <th style="width: 15%">盘库数量</th>
                </tr>
                <tr v-for = "(item,index) in mainData[0]" :key="index">
                    <td>{{item.ID}}</td>
                    <td>{{item.PRODUCT_NAME}}</td>
                    <td>{{item.TYPE_UNIT}}</td>
                    <td v-if="WAREHOUSE_MODE == 2">{{item.LOCATION_CODE}}</td>
                    <td>{{item.PRODUCT_COUNT}}</td>
                    <td></td>
                </tr>
            </table>
        </el-col>
    </el-row>
    <!--分页-->
    <el-row>
        <el-col :span="3" :offset="21" style="padding: 0">
            <p>第{{mainData[0].currentPage}}页/共{{mainData[0].totalPage}}页</p>
        </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    stockCode: String,
    stockDate: String,
  },
  data() {
    return {
      topData: [],
      mainData: [],
      stock_code: '',
      stock_date: '',
      imgUrl: '',
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
    };
  },
  created() {
    this.topData = this.headerData;
    this.mainData.push(this.tableData);
    this.stock_date = this.stockDate;
    this.stock_code = this.stockCode;
    // this.imgUrl = 'https://service.linkda.com.cn/file/barcode/'+ this.topData[0].ORDER_ID + '.png'
    this.imgUrl = `http://47.99.59.146/file/barcode/${this.topData[0].ORDER_ID}.png`;
  },
};
</script>
<style scoped>
    ul{
        margin-top: 0;
        padding-top: 0;
        padding-left: 0;
    }
    li{
        list-style: none;
        font-size: 20px;
        line-height: 30px;
        color: #000;
        font-family: 黑体;
    }
    span{
        font-size: 20px;
        line-height: 35px;
        color: #000;
        font-family: 黑体;
    }
    table {
        border-collapse: collapse;
        width: 130%;
        border: 1px solid #000;
        font-weight: bold;
    }
    td,th {
        border: 1px solid #000;
        text-align: center;
        font-weight: normal;
        /*padding: 5px 10px;*/
        font-size: 22px;
        height: 30px;
        font-family: 黑体;
        color: #000;
    }
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/newOrderTax.vue